
@file:Suppress("unused")
package tk.mallumo.compose.navigation

import tk.mallumo.compose.navigation.ArgumentsNavigation


/**
 * @see ui.app.assign.AppAssignListingUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_AppAssignListingUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.AppAssignListingUI, args, clearTop)
}


/**
 * @see ui.app.assign.AppAssignListingUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_AppAssignListingUI(args: ui.app.assign.AppAssignListingArgs, clearTop: Boolean = false) {
    navigateTo(Node.AppAssignListingUI, args.asBundle(), clearTop)
}


/**
 * @see ui.app.assign.detail.AppDetailUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_AppDetailUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.AppDetailUI, args, clearTop)
}


/**
 * @see ui.app.assign.detail.AppDetailUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_AppDetailUI(args: ui.app.assign.detail.AppDetailArgs, clearTop: Boolean = false) {
    navigateTo(Node.AppDetailUI, args.asBundle(), clearTop)
}


/**
 * @see ui.app.assign.detail.kindergarten.editor.AppKindergartenEditorUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_AppKindergartenEditorUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.AppKindergartenEditorUI, args, clearTop)
}


/**
 * @see ui.app.assign.detail.kindergarten.editor.AppKindergartenEditorUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_AppKindergartenEditorUI(args: ui.app.assign.detail.AppDetailArgs, clearTop: Boolean = false) {
    navigateTo(Node.AppKindergartenEditorUI, args.asBundle(), clearTop)
}


/**
 * @see ui.app.assign.detail.kindergarten.preview.AppKindergartenPreviewUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_AppKindergartenPreviewUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.AppKindergartenPreviewUI, args, clearTop)
}


/**
 * @see ui.app.assign.detail.kindergarten.preview.AppKindergartenPreviewUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_AppKindergartenPreviewUI(args: ui.app.assign.detail.AppDetailArgs, clearTop: Boolean = false) {
    navigateTo(Node.AppKindergartenPreviewUI, args.asBundle(), clearTop)
}


/**
 * @see ui.app.assign.detail.wheel.editor.AppEditorWheelUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_AppEditorWheelUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.AppEditorWheelUI, args, clearTop)
}


/**
 * @see ui.app.assign.detail.wheel.editor.AppEditorWheelUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_AppEditorWheelUI(args: ui.app.assign.detail.AppDetailArgs, clearTop: Boolean = false) {
    navigateTo(Node.AppEditorWheelUI, args.asBundle(), clearTop)
}


/**
 * @see ui.app.assign.detail.wheel.preview.AppPreviewWheelUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_AppPreviewWheelUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.AppPreviewWheelUI, args, clearTop)
}


/**
 * @see ui.app.assign.detail.wheel.preview.AppPreviewWheelUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_AppPreviewWheelUI(args: ui.app.assign.detail.AppDetailArgs, clearTop: Boolean = false) {
    navigateTo(Node.AppPreviewWheelUI, args.asBundle(), clearTop)
}


/**
 * @see ui.app.rss.AppRssListingUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_AppRssListingUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.AppRssListingUI, args, clearTop)
}


/**
 * @see ui.app.rss.AppRssListingUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_AppRssListingUI(args: ui.app.rss.AppRssListingArgs, clearTop: Boolean = false) {
    navigateTo(Node.AppRssListingUI, args.asBundle(), clearTop)
}


/**
 * @see ui.app.rss.channel.AppRssListingChannelUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_AppRssListingChannelUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.AppRssListingChannelUI, args, clearTop)
}


/**
 * @see ui.app.rss.channel.AppRssListingChannelUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_AppRssListingChannelUI(args: ui.app.rss.AppRssListingArgs, clearTop: Boolean = false) {
    navigateTo(Node.AppRssListingChannelUI, args.asBundle(), clearTop)
}


/**
 * @see ui.app.rss.instance.AppRssListingInstanceUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_AppRssListingInstanceUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.AppRssListingInstanceUI, args, clearTop)
}


/**
 * @see ui.app.rss.instance.AppRssListingInstanceUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_AppRssListingInstanceUI(args: ui.app.rss.AppRssListingArgs, clearTop: Boolean = false) {
    navigateTo(Node.AppRssListingInstanceUI, args.asBundle(), clearTop)
}


/**
 * @see ui.app.rss.instance.detail.AppRssDetailInstanceUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_AppRssDetailInstanceUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.AppRssDetailInstanceUI, args, clearTop)
}


/**
 * @see ui.app.rss.instance.detail.AppRssDetailInstanceUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_AppRssDetailInstanceUI(args: ui.app.rss.instance.detail.AppRssDetailInstanceArgs, clearTop: Boolean = false) {
    navigateTo(Node.AppRssDetailInstanceUI, args.asBundle(), clearTop)
}


/**
 * @see ui.app.visibility.AppVisibilityListingUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_AppVisibilityListingUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.AppVisibilityListingUI, args, clearTop)
}


/**
 * @see ui.app.visibility.AppVisibilityListingUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_AppVisibilityListingUI(args: ui.app.visibility.AppVisibilityListingArgs, clearTop: Boolean = false) {
    navigateTo(Node.AppVisibilityListingUI, args.asBundle(), clearTop)
}


/**
 * @see ui.campaign.CampaignListingUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_CampaignListingUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.CampaignListingUI, args, clearTop)
}


/**
 * @see ui.campaign.CampaignListingUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_CampaignListingUI(args: ui.campaign.CampaignListingArgs, clearTop: Boolean = false) {
    navigateTo(Node.CampaignListingUI, args.asBundle(), clearTop)
}


/**
 * @see ui.campaign.detailv2.editor.CampaignEditorUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_CampaignEditorUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.CampaignEditorUI, args, clearTop)
}


/**
 * @see ui.campaign.detailv2.editor.CampaignEditorUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_CampaignEditorUI(args: ui.campaign.detailv2.editor.CampaignEditorArgs, clearTop: Boolean = false) {
    navigateTo(Node.CampaignEditorUI, args.asBundle(), clearTop)
}


/**
 * @see ui.campaign.detailv2.preview.CampaignPreviewUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_CampaignPreviewUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.CampaignPreviewUI, args, clearTop)
}


/**
 * @see ui.campaign.detailv2.preview.CampaignPreviewUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_CampaignPreviewUI(args: ui.campaign.detailv2.preview.CampaignPreviewArgs, clearTop: Boolean = false) {
    navigateTo(Node.CampaignPreviewUI, args.asBundle(), clearTop)
}


/**
 * @see ui.company.CompanyListingUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_CompanyListingUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.CompanyListingUI, args, clearTop)
}


/**
 * @see ui.company.detail.CompanyUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_CompanyUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.CompanyUI, args, clearTop)
}


/**
 * @see ui.company.detail.CompanyUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_CompanyUI(args: ui.company.detail.CompanyArgs, clearTop: Boolean = false) {
    navigateTo(Node.CompanyUI, args.asBundle(), clearTop)
}


/**
 * @see ui.console.ConsoleUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_ConsoleUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.ConsoleUI, args, clearTop)
}


/**
 * @see ui.console.ConsoleUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_ConsoleUI(args: ui.console.ConsoleArgs, clearTop: Boolean = false) {
    navigateTo(Node.ConsoleUI, args.asBundle(), clearTop)
}


/**
 * @see ui.dashboard.DashboardUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_DashboardUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.DashboardUI, args, clearTop)
}


/**
 * @see ui.dashboard.DashboardUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_DashboardUI(args: ui.dashboard.ArgsDashboard, clearTop: Boolean = false) {
    navigateTo(Node.DashboardUI, args.asBundle(), clearTop)
}


/**
 * @see ui.device.DeviceListingUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_DeviceListingUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.DeviceListingUI, args, clearTop)
}


/**
 * @see ui.device.DeviceListingUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_DeviceListingUI(args: ui.device.DeviceListingArgs, clearTop: Boolean = false) {
    navigateTo(Node.DeviceListingUI, args.asBundle(), clearTop)
}


/**
 * @see ui.device.detail.editor.DeviceEditorUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_DeviceEditorUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.DeviceEditorUI, args, clearTop)
}


/**
 * @see ui.device.detail.editor.DeviceEditorUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_DeviceEditorUI(args: ui.device.detail.editor.DeviceEditorArgs, clearTop: Boolean = false) {
    navigateTo(Node.DeviceEditorUI, args.asBundle(), clearTop)
}


/**
 * @see ui.device.detail.preview.DevicePreviewUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_DevicePreviewUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.DevicePreviewUI, args, clearTop)
}


/**
 * @see ui.device.detail.preview.DevicePreviewUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_DevicePreviewUI(args: ui.device.detail.DeviceArgs, clearTop: Boolean = false) {
    navigateTo(Node.DevicePreviewUI, args.asBundle(), clearTop)
}


/**
 * @see ui.hardware.HardwareListingUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_HardwareListingUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.HardwareListingUI, args, clearTop)
}


/**
 * @see ui.hardware.detail.HardwareDetailUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_HardwareDetailUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.HardwareDetailUI, args, clearTop)
}


/**
 * @see ui.hardware.detail.HardwareDetailUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_HardwareDetailUI(args: ui.hardware.detail.HardwareDetailArgs, clearTop: Boolean = false) {
    navigateTo(Node.HardwareDetailUI, args.asBundle(), clearTop)
}


/**
 * @see ui.home.HomeUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_HomeUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.HomeUI, args, clearTop)
}


/**
 * @see ui.home.HomeUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_HomeUI(args: ui.ArgsInitial, clearTop: Boolean = false) {
    navigateTo(Node.HomeUI, args.asBundle(), clearTop)
}


/**
 * @see ui.EmptyUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_EmptyUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.EmptyUI, args, clearTop)
}


/**
 * @see ui.license.LicenseListingUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_LicenseListingUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.LicenseListingUI, args, clearTop)
}


/**
 * @see ui.license.detail.LicenseDetailUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_LicenseDetailUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.LicenseDetailUI, args, clearTop)
}


/**
 * @see ui.license.detail.LicenseDetailUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_LicenseDetailUI(args: ui.license.detail.LicenseArgs, clearTop: Boolean = false) {
    navigateTo(Node.LicenseDetailUI, args.asBundle(), clearTop)
}


/**
 * @see ui.location.LocationListingUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_LocationListingUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.LocationListingUI, args, clearTop)
}


/**
 * @see ui.location.LocationListingUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_LocationListingUI(args: ui.location.LocationListingArgs, clearTop: Boolean = false) {
    navigateTo(Node.LocationListingUI, args.asBundle(), clearTop)
}


/**
 * @see ui.location.detail.LocationUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_LocationUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.LocationUI, args, clearTop)
}


/**
 * @see ui.location.detail.LocationUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_LocationUI(args: ui.location.detail.LocationArgs, clearTop: Boolean = false) {
    navigateTo(Node.LocationUI, args.asBundle(), clearTop)
}


/**
 * @see ui.login.LoginUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_LoginUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.LoginUI, args, clearTop)
}


/**
 * @see ui.login.LoginUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_LoginUI(args: ui.ArgsInitial, clearTop: Boolean = false) {
    navigateTo(Node.LoginUI, args.asBundle(), clearTop)
}


/**
 * @see ui.report.campaign.ReportCampaignUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_ReportCampaignUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.ReportCampaignUI, args, clearTop)
}


/**
 * @see ui.report.campaign.ReportCampaignUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_ReportCampaignUI(args: ui.report.campaign.ReportCampaignArgs, clearTop: Boolean = false) {
    navigateTo(Node.ReportCampaignUI, args.asBundle(), clearTop)
}


/**
 * @see ui.report.device.ReportDeviceAliveUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_ReportDeviceAliveUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.ReportDeviceAliveUI, args, clearTop)
}


/**
 * @see ui.report.device.ReportDeviceAliveUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_ReportDeviceAliveUI(args: ui.report.device.ReportDeviceArgs, clearTop: Boolean = false) {
    navigateTo(Node.ReportDeviceAliveUI, args.asBundle(), clearTop)
}


/**
 * @see ui.report.device.ReportDeviceSystemUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_ReportDeviceSystemUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.ReportDeviceSystemUI, args, clearTop)
}


/**
 * @see ui.report.device.ReportDeviceSystemUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_ReportDeviceSystemUI(args: ui.report.device.ReportDeviceArgs, clearTop: Boolean = false) {
    navigateTo(Node.ReportDeviceSystemUI, args.asBundle(), clearTop)
}


/**
 * @see ui.resource.ResourceListingUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_ResourceListingUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.ResourceListingUI, args, clearTop)
}


/**
 * @see ui.resource.ResourceListingUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_ResourceListingUI(args: ui.resource.ResourceListingArgs, clearTop: Boolean = false) {
    navigateTo(Node.ResourceListingUI, args.asBundle(), clearTop)
}


/**
 * @see ui.resource.detail.ResourceUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_ResourceUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.ResourceUI, args, clearTop)
}


/**
 * @see ui.resource.detail.ResourceUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_ResourceUI(args: ui.resource.detail.ResourceArgs, clearTop: Boolean = false) {
    navigateTo(Node.ResourceUI, args.asBundle(), clearTop)
}


/**
 * @see ui.resource.editor.VisualEditorUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_VisualEditorUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.VisualEditorUI, args, clearTop)
}


/**
 * @see ui.resource.editor.VisualEditorUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_VisualEditorUI(args: ui.resource.editor.VisualEditorArgs, clearTop: Boolean = false) {
    navigateTo(Node.VisualEditorUI, args.asBundle(), clearTop)
}


/**
 * @see ui.resource.icons.IconsListingUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_IconsListingUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.IconsListingUI, args, clearTop)
}


/**
 * @see ui.server.ServerListingUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_ServerListingUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.ServerListingUI, args, clearTop)
}


/**
 * @see ui.server.detail.ServerUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_ServerUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.ServerUI, args, clearTop)
}


/**
 * @see ui.server.detail.ServerUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_ServerUI(args: ui.server.detail.ServerArgs, clearTop: Boolean = false) {
    navigateTo(Node.ServerUI, args.asBundle(), clearTop)
}


/**
 * @see ui.translation.TranslationListingUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_TranslationListingUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.TranslationListingUI, args, clearTop)
}


/**
 * @see ui.user.UserListingUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_UserListingUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.UserListingUI, args, clearTop)
}


/**
 * @see ui.user.UserListingUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_UserListingUI(args: ui.user.UserListingArgs, clearTop: Boolean = false) {
    navigateTo(Node.UserListingUI, args.asBundle(), clearTop)
}


/**
 * @see ui.user.detail.UserUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_UserUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.UserUI, args, clearTop)
}


/**
 * @see ui.user.detail.UserUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_UserUI(args: ui.user.detail.UserArgs, clearTop: Boolean = false) {
    navigateTo(Node.UserUI, args.asBundle(), clearTop)
}

